import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'footer-contact-info',
  styleUrl: 'footer-contact-info.scss',
  shadow: true
})
export class FooterContactInfo {
  @Prop() assetPath: string = '';
  @Prop() footerSupportEmail: string[] = [];
  @Prop() footerSupportContactNo1: string = '';
  @Prop() footerSupportContactNo2: string = '';
  @Prop() footerSupportEmail1: string = '';
  @Prop() footerSupportEmail2: string = '';
  @Prop() supportTiming: string = '';

  render() {
    const supportEmails = [this.footerSupportEmail1, this.footerSupportEmail2].filter(email => !!email);
    const supportNumbers = [this.footerSupportContactNo1, this.footerSupportContactNo2].filter(number => !!number);
    return (
      <Host>
        <div class="flex items-stretch flex-col md:flex-row flex-wrap gap-3">
          {/* Email Section */}
          <div class="flex items-center gap-2 bg-white p-2 rounded-xl text-xs flex-1 md:flex-none">
            <img src={`${this.assetPath}images/icons/email.svg`} alt="Email" height="16" />
            <div>
              <p class="text-black text-xs my-0.5">Email Us At</p>
              {supportEmails?.map(email => (
                <a href={`mailto:${email}`} class="font-bold block text-blue-700" key={email}>
                  {email}
                </a>
              ))}
            </div>
          </div>

          {/* Contact No Section */}
          <div class="flex items-center gap-2 bg-white p-2 rounded-xl text-xs flex-1">
            <img src={`${this.assetPath}images/icons/telephone.svg`} alt="Phone" height="16" />
            <div class="max-w-[200px]">
              <p class="text-black text-xs my-0.5">Call Us On</p>
              {supportNumbers.map((number, index) => (
                <span key={index}>
                  <a href={`tel:${number.replace(/\s+/g, '')}`} class="font-medium text-blue-700 no-underline">
                    {number}
                  </a>
                  {index < supportNumbers.length - 1 && ' / '}
                </span>
              ))}
              <span class="text-gray-800 block">{this.supportTiming}</span>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
